import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { KnzComponentProps } from '../../../types';
import { SERIF_FONT } from './proseStyle';

/**
 * 読み物の強調囲み（背骨の一文・一番伝えたい主張を際立たせる）。
 * 本文と同じ明朝だが、左に細いアクセントボーダー + わずかな背景で区別する。
 * 明朝の紙面の静けさを壊さないよう、記事全体で 1〜2 箇所だけの使用を想定。
 * params: text（joined, Markdown 可）、variant（任意, quiet / strong。既定 quiet）
 */
export const ProseCallout: React.FC<KnzComponentProps> = ({ node, renderInline }) => {
  const text = (node.params.text as string) ?? '';
  const variant = (node.params.variant as string) === 'strong' ? 'strong' : 'quiet';
  const strong = variant === 'strong';

  return (
    <Box
      sx={{
        borderLeft: strong ? '4px solid #1A1A1A' : '3px solid #888',
        bgcolor: 'rgba(0, 0, 0, 0.03)',
        pl: 2,
        pr: 1.5,
        py: 1.5,
        my: 2.5,
      }}
    >
      <Typography
        component="div"
        sx={{
          fontSize: 14,
          fontFamily: SERIF_FONT,
          color: '#1A1A1A',
          fontWeight: strong ? 700 : 400,
          lineHeight: 2.0,
          '& .wmde-markdown, & .wmde-markdown p, & .wmde-markdown span': {
            margin: 0,
            fontFamily: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            color: 'inherit',
            background: 'transparent',
          },
        }}
      >
        {renderInline(text)}
      </Typography>
    </Box>
  );
};

export default ProseCallout;
